import { InjectionToken, Provider } from '@angular/core';

/**
 * Canonical Firestore collection / history-code strings shared by client + admin.
 * These are not environment-specific (same in dev/prod).
 */
export const FIRESTORE_PATHS = {
  FB_ADMINS: 'admins',
  FB_RESELLERS: 'resellers',
  FB_CLIENTS: 'clients',
  FB_CLIENTS_NEW: 'clients_new',
  FB_CLIENTS_ADMINS: 'clients_admins',
  FB_CLIENTS_ADMINS_NEW: 'clients_admins_new',
  FB_HISTORY_SUB_ITEMS: 'history',
  FB_FLOAT_HISTORY: 'float_history',
  HISTORY_MANUAL_FLOAT_EDITS: 'manual_float_edits',
  HISTORY_MANUAL_SMS_CREDITS_EDITS: 'manual_sms_credits_edits',
} as const;

/** Paths required by reseller domain helpers in `@eneza/shared`. */
export type EnezaResellerFirestorePaths = Pick<
  typeof FIRESTORE_PATHS,
  | 'FB_CLIENTS'
  | 'FB_RESELLERS'
  | 'FB_CLIENTS_NEW'
  | 'FB_HISTORY_SUB_ITEMS'
  | 'FB_FLOAT_HISTORY'
  | 'HISTORY_MANUAL_FLOAT_EDITS'
  | 'HISTORY_MANUAL_SMS_CREDITS_EDITS'
>;

export const DEFAULT_RESELLER_FIRESTORE_PATHS: EnezaResellerFirestorePaths = {
  FB_CLIENTS: FIRESTORE_PATHS.FB_CLIENTS,
  FB_RESELLERS: FIRESTORE_PATHS.FB_RESELLERS,
  FB_CLIENTS_NEW: FIRESTORE_PATHS.FB_CLIENTS_NEW,
  FB_HISTORY_SUB_ITEMS: FIRESTORE_PATHS.FB_HISTORY_SUB_ITEMS,
  FB_FLOAT_HISTORY: FIRESTORE_PATHS.FB_FLOAT_HISTORY,
  HISTORY_MANUAL_FLOAT_EDITS: FIRESTORE_PATHS.HISTORY_MANUAL_FLOAT_EDITS,
  HISTORY_MANUAL_SMS_CREDITS_EDITS: FIRESTORE_PATHS.HISTORY_MANUAL_SMS_CREDITS_EDITS,
};

export const ENEZA_RESELLER_FIRESTORE_PATHS = new InjectionToken<EnezaResellerFirestorePaths>(
  'eneza.reseller.firestorePaths',
);

/** Provide reseller path constants (defaults to {@link DEFAULT_RESELLER_FIRESTORE_PATHS}). */
export function provideResellerFirestorePaths(
  paths: EnezaResellerFirestorePaths = DEFAULT_RESELLER_FIRESTORE_PATHS,
): Provider {
  return { provide: ENEZA_RESELLER_FIRESTORE_PATHS, useValue: paths };
}
